import React from "react"
import ReviewsTable from "../components/reviews-table"

const Tooltip = () => {
  return (
    <div className="reviews-f tooltiptext">
      <div id="triangle-up-2"></div>
      <ReviewsTable />
    </div>
  )
}
export default Tooltip
